export default {
    'keep-kr': '@:terms.keep-kr',
    'title': '@:terms.taxrefund 조회',
    'analyzing': '계산중',
    'amount': '환급액',
    'suggest': {
        'before-analysis': '무료로 조회하기',
        'before-confirm': '환급액을 확인하세요',
    },
    'story': {
        'about-others': '다른 회사가 받는 환급액은 얼마?',
        'need-minutes': '5분만 투자해서 지난 5년간의 환급금을 알아보세요.' +
                        '\n\n*지금은 법인사업자만 조회가 가능합니다.' +
                        '\n\n*개인사업자는 지금 공동인증서를 등록해 주시면 추후 서비스 오픈 시 환급금액을 안내해 드리겠습니다.',
        'average': '2명 중 1명이 평균 942만 원의 환급금을 찾아갔습니다.',
        'progressing': '혜움의 세무사들이\n예상 환급금을 계산 중입니다.',
        'please-waiting': '5분만 투자해서 지난 5년간\n누락 환급금을 알아보세요.' +
                          '\n\n*지금은 법인사업자만 조회가 가능합니다.' +
                          '\n\n*개인사업자는 지금 공동인증서를 등록해 주시면 추후 서비스 오픈 시 환급금액을 안내해 드리겠습니다.',
    },
    'action-leading': {
        'sales': '{company}의\n최근 5년간 매출은\n총 {amount}원입니다.',
        'sales-amount': '최근 5년간 매출',
        'taxes': '{company}의\n최근 5년간 납부한 세금은\n총 {amount}원입니다.',
        'taxes-amount': '최근 5년간 납부한 세금',
        'taxrefund': '{company}의\n환급 가능한 최대 금액은\n총 {amount}원입니다.',
        'taxrefund-amount': '환급 가능한 최대 금액',
        'tax-accountant': '혜움의 전담 세무사들이\n{amount}원 환급을 도와드립니다.',
        'tax-accountant-follow': '혜움에서는 국세청, 삼일회계법인 출신의 세무사, 회계사가 세금 환급을 전담하고 있습니다.',
        'not-found-taxrefund': '아쉽게도,\n환급가능한 금액이 없습니다.',
        'not-found-taxrefund-follow': '추가적인  절세 상담을 받아보세요.\n혜움은  가장  만족도가 높은  세무 서비스입니다.',
        'total-amount': '총 {amount}원',
    },
    'buttons': {
      'next': '다음',
      'inquire': '환급액 조회하기',
      'contact': '환급 신청하기',
      'consulting': '세무 기장 상담 받기',
      'review': '분석 결과 다시 보기',
    },
    'popup': {
        'contact-title': '환급신청 안내',
        'contact-message': '이재희 대표 세무사입니다.' +
                           '\n환급신청 접수를 도와드리게 되어 반갑습니다.' +
                           '\n\n환급신청은 경정청구를  통해 이루어지며 국세청 권고사항으로 어떠한 불이익도 없습니다.' +
                           '\n\n특히, 환급전까지는 어떠한 비용도 발생하지 않으니, 부담없이 신청하셔도 됩니다.' +
                           '\n\n카톡으로 자세한 신청 안내서를 보내드리겠습니다.',
        'consulting-title': '세무 기장 상담 접수  안내',
        'consulting-message': '이재희 세무사입니다.' +
                              '\n\n기장 상담을 신청해주셔서 감사합니다.' +
                              '\n\n혜움의 담당자가 전화로 곧 연락을 드리겠습니다. 약 1~2일 정도 소요됩니다.',
    },
}
